exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e27d2ce8]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.masechta-container[data-v-e27d2ce8]:hover {\n  text-decoration: none;\n}\n.masechta-container .masechta .masechta-title[data-v-e27d2ce8] {\n  background: #aa4121;\n  font-size: 1rem;\n}\n.masechta-container .masechta .card-body[data-v-e27d2ce8] {\n  color: #aa4121;\n}\n.masechta-container .masechta .card-body h5[data-v-e27d2ce8] {\n  font-size: 1rem;\n}", ""]);

// exports
